import { render, staticRenderFns } from "./RestoreCamera.vue?vue&type=template&id=6683013d"
import script from "./RestoreCamera.vue?vue&type=script&lang=js"
export * from "./RestoreCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports